<template>
  <div class="advantage">
    <ul class="advantage-list">

      <li class="advantage-item">
        <div class="item-header">
          <i class="iconfont icon-tuandui"/>
          <div class="title">
            <div class="number">6000M</div>
<!--            <div class="text">Quality Assurance</div>-->
          </div>
        </div>
        <p class="advantage-content">
          RCH’s underwater camera, underwater illumination, underwater gimbal / pan / tilts, underwater optical transceivers, underwater connectors, underwater manipulators, underwater laser, underwater propellers, underwater robots can work in an area of 6000 meters under the sea.
        </p>
      </li>

      <li class="advantage-item">
        <div class="item-header">
          <i class="iconfont icon-shijian"/>
          <div class="title">
            <div class="number">R&D</div>
<!--            <div class="text">Automation Production</div>-->
          </div>
        </div>
        <p class="advantage-content">
          In terms of technology research and development, we focus on cooperation with domestic and foreign professional institutions for joint development and research to maintain our leading position in the industry. We have established close cooperative relationships with many well-known universities and scientific research institutions, and have in-depth cooperation in the fields of intelligent control, materials science and other fields, providing strong support for the research and development of marine underwater equipment.
        </p>
      </li>

      <li class="advantage-item">
        <div class="item-header">
          <i class="iconfont icon-chanpin"/>
          <div class="title">
            <div class="number">Customized Solution</div>
<!--            <div class="text">Monthly Capacity</div>-->
          </div>
        </div>
        <p class="advantage-content">
          Customized solution services are available. Our professional R&D team and engineers can design the most suitable equipment and solutions based on customer needs and practical application scenarios. We will comprehensively consider various factors in the design process, including water depth, temperature, water quality, etc., to provide customers with the most suitable solution, provide one-stop after-sales service, including equipment maintenance, repair, upgrading, etc
        </p>
      </li>

<!--      <li class="advantage-item">-->
<!--        <div class="item-header">-->
<!--          <i class="iconfont icon-jituanqiye"/>-->
<!--          <div class="title">-->
<!--            <div class="number">75%</div>-->
<!--            <div class="text">Research and Development</div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <p class="advantage-content">-->
<!--          75% of R&D personnel have been engaged in the backlight for more than 10 years. Optical simulation can be performed according to the client with OC spectrum.-->
<!--        </p>-->
<!--      </li>-->
    </ul>
  </div>
</template>

<script setup lang="ts">

</script>

<style lang="stylus" scoped>
.advantage
  background #f6fbfe
  padding 20px 0
  &-list
    display flex
    justify-content center
    max-width 1510px
    min-width 1280px
    margin 0 auto
    box-sizing border-box
    .advantage-item
      padding 30px 30px 0
      flex 1
      color #031146
      transition .3s
      &:hover
        color #00b1f5!important
        cursor pointer
      .item-header
        display flex
        align-items center
        .iconfont
          margin-right 16px
          font-size 20px
        .title
          font-size 32px
          font-weight 300
          .number
            font-size 32px
          .text
            font-size 16px
            margin-top 8px

      .advantage-content
        margin-top 16px
        line-height 26px
        font-size 16px
        font-weight 300
</style>
